import { RouteConfig } from 'vue-router';
import useI18n from '@/mixins/useI18n';
import { getDefaultRobots } from '@/utils/publicSite';
import PublicBlog from '@/views/public/blog/PublicBlog.vue';
import PublicBlogArticle from '@/views/public/blog/PublicBlogArticle.vue';
import { resolvePublicArticleSeoMeta } from '../publicArticleSeo';

const { t } = useI18n();

const createPublicArticleMeta = () => ({
  layout: 'landingpage',
  title: t('blog.meta.title') || 'Blog',
  description: t('blog.meta.description') || 'Blog articles',
  robots: getDefaultRobots(),
});

const syncPublicArticleRouteSeo: RouteConfig['beforeEnter'] = (to, _from, next) => {
  Object.assign(to.meta, createPublicArticleMeta(), {
    canonical: undefined,
    image: undefined,
    ogType: undefined,
    twitterCard: undefined,
    structuredData: undefined,
  });

  const resolvedArticle = resolvePublicArticleSeoMeta(to);

  if (!resolvedArticle) {
    next();
    return;
  }

  if (to.path !== resolvedArticle.path) {
    next({
      path: resolvedArticle.path,
      query: to.query,
      hash: to.hash,
      replace: true,
    });
    return;
  }

  Object.assign(to.meta, resolvedArticle.seoMeta);
  next();
};

const routes: RouteConfig[] = [
  {
    name: 'blog-public',
    path: '/pblog',
    component: PublicBlog,
    meta: {
      layout: 'landingpage',
      title: t('blog.meta.title') || 'Blog',
      description: t('blog.meta.description') || 'Blog articles',
    }
  },
  {
    name: 'blog-public-article',
    path: '/pblog/articles/:articleId',
    component: PublicBlogArticle,
    props: true,
    meta: {
      ...createPublicArticleMeta(),
      publicPrerenderReadyHandledByComponent: true,
    },
    beforeEnter: syncPublicArticleRouteSeo,
  },
];

export default routes;
